import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Rerun from '../../../../webcommon/common/Icons/Rerun.svg';
import Details from '../../../../webcommon/common/Icons/Details.svg';
import TickPositive from '../../../../webcommon/common/Icons/Tick-Positive.svg';
import CrossNegative from '../../../../webcommon/common/Icons/Cross-Negative.svg';
import ExclamationOrange from '../../../../webcommon/common/Icons/Exclamation-Orange.svg';

import Tooltip from 'rc-tooltip';
import { noop } from 'lodash';
import defaultStyles from './Status.module.scss';
import 'rc-tooltip/assets/bootstrap.css';

const isGreen = status => (
    status === 'Uploaded' || status === 'Executed' || status === "IceFilesDownloaded"
);

const isBlue = status => (
    status === 'Requested'
);

const isRed = status => (
    status === 'Not Uploaded' || status === 'Errored' || status === 'FilesUnavailable'
);
const isOrange = status => (
    status === 'ExecutedWithWarning' || status === 'IAFilesUnavailable' || status === 'IceFilesUnavailable'
);

const WebJobsStatus = (props) => {
    const { id, setDetailsBeingViewed, rerunSelectedRow } = props;
    const viewDetails = useCallback(() => setDetailsBeingViewed(id),
        [id, setDetailsBeingViewed]);

    const rerunSelectedRowFunc = useCallback(() => rerunSelectedRow([id]),
        [id, rerunSelectedRow]);

    return (
        <div className={ classnames({
            [props.styles.uploaded]: isGreen(props.status),
            [props.styles.requested]: isBlue(props.status),
            [props.styles.error]: isRed(props.status),
            [props.styles.warning]: isOrange(props.status),
            [props.styles.status]: true
        }) }
        >

            {isGreen(props.status) && (
                <button className={ props.styles.tooltip } type="button">
                    <img
                        alt="Success"
                        src={ TickPositive }
                        className={ props.styles.svg }
                    />
                </button>
            )}

            {isRed(props.status) && (
                <button className={ props.styles.tooltip } type="button">
                    <img
                        alt="Error"
                        src={ CrossNegative }
                        className={ props.styles.svg }
                    />
                </button>
            )}
            {isOrange(props.status) && (
                <button className={ props.styles.tooltip } type="button">
                    <img
                        alt="Warning"
                        src={ ExclamationOrange }
                        className={ props.styles.svg }
                    />
                </button>
            )}

            <div>
                {props.status}
            </div>


            { props.showIcons ? (
                <>
                    <Tooltip
                        placement="bottom"
                        overlay="Details"
                        arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
                    >
                        <div className={ props.styles.webJobsInfo } href="#">
                            <button onClick={ viewDetails } className={ props.styles.tooltip } type="button">
                                <img
                                    alt="Details"
                                    src={ Details }
                                    className={ props.styles.svg }
                                />
                            </button>
                        </div>
                    </Tooltip>

                    <Tooltip
                        placement="bottom"
                        overlay="Rerun"
                        arrowContent={ <div className="rc-tooltip-arrow-inner" /> }
                    >
                        <div className={ props.styles.webJobsRerun } href="#">
                            <button onClick={ rerunSelectedRowFunc } className={ props.styles.tooltip } type="button">
                                <img
                                    alt="Rerun"
                                    src={ Rerun }
                                    className={ props.styles.svg }
                                />
                            </button>
                        </div>
                    </Tooltip>
                </>
            ) : null }
        </div>
    );
};


WebJobsStatus.propTypes = {
    id: PropTypes.string,
    rerunSelectedRow: PropTypes.func,
    setDetailsBeingViewed: PropTypes.func,
    showIcons: PropTypes.bool,
    status: PropTypes.string,
    styles: PropTypes.objectOf(PropTypes.string)
};

WebJobsStatus.defaultProps = {
    id: '',
    rerunSelectedRow: noop,
    setDetailsBeingViewed: noop,
    showIcons: false,
    status: '',
    styles: defaultStyles
};

export default WebJobsStatus;
